import React, { useState, useEffect } from 'react'
import get from 'lodash/get'

import { sendTeaCommEvent } from 'lib/tea-analyze'

import { ISwiperAD } from './ad/interface'
import TodayNews from 'Pages/home/today-news'
import { useAdData } from './context'
import SwiperAD from './ad/swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'
import ArticleLink from 'Components/links/article-link'
import applyHttpsImage from 'lib/apply-https-img'

SwiperCore.use([Navigation, Pagination, Autoplay])

export interface IBannerList {
  open_url: string
  img_url: string
  title: string
  gid: string
}

interface IProps {
  banner: IBannerList[]
  todayNews: any
}

const adPositionMap: any = {
  second_frames_banner_ad: 1,
  forth_frames_banner_ad: 3,
  five_frames_banner_ad: 4,
  six_frames_banner_ad: 5,
  seven_frames_banner_ad: 6,
  eight_frames_banner_ad: 7,
  nine_frames_banner_ad: 8,
}

export default function Banner({ banner, todayNews }: IProps) {
  const [showBanner, setShowBanner] = useState(false)
  useEffect(() => {
    setShowBanner(true)
  }, [])
  return (
    <div className="wrapper clearfix focus-banner">
      {showBanner ? (
        <BannerSwiper banner={banner} />
      ) : (
        <div className="placeholder" />
      )}
      <TodayNews todayNews={todayNews} />
      <style jsx>
        {`
          .wrapper {
            margin-top: 27px;
            position: relative;
          }
          .placeholder {
            float: left;
            width: 800px;
            height: 316px;
            background: #f5f5f5;
          }
        `}
      </style>
    </div>
  )
}

function BannerSwiper({ banner }: { banner: IBannerList[] }) {
  const adData = useAdData()
  const [swiperInstance, setSwiperInstance] = useState<any>()

  const bannerWithAd = React.useMemo<(IBannerList | ISwiperAD)[] | null>(() => {
    const newBanner: (IBannerList | ISwiperAD)[] = [...banner]
    // 广告加载中
    if (adData === undefined) {
      return null
    }
    // 没有广告
    if (adData === null) {
      return banner
    }
    // 替换改成插入，非广告数据后移
    Object.keys(adPositionMap).map((item: string) => {
      if ((adData as any)[item]) {
        newBanner.splice(adPositionMap[item], 0, (adData as any)[item])
      }
      return item
    })
    return newBanner.filter(item => !!item)
  }, [adData, banner])
  if (!bannerWithAd) {
    return (
      <div className="fl wrapper">
        <style jsx>
          {`
            div {
              width: 800px;
              height: 316px;
              background: #f5f5f5;
            }
          `}
        </style>
      </div>
    )
  }
  const params = {
    autoplay: {
      disableOnInteraction: false,
      delay: 4000,
    },
    navigation: {
      nextEl: '.banner-nav-next',
      prevEl: '.banner-nav-pre',
    },
    pagination: {
      el: '.banner-swiper-pagination',
      type: 'bullets' as any,
      bulletActiveClass: 'banner-active-bullet',
      bulletClass: 'banner-bullet',
      clickable: true,
    },
    spaceBetween: 30,
    loop: true,
    onSlideChangeTransitionStart() {
      let index = get(this, 'activeIndex', 1) - 1
      index = index < 0 ? banner.length - 1 : index
      index = index >= banner.length ? 0 : index
      const data = get(banner, `${index}`)
      sendTeaCommEvent('show_home_banner', {
        group_id: data.gid,
        rank: index,
        material_url: data.img_url,
      })
    },
    getSwiper: setSwiperInstance,
  }
  return (
    <div
      className="fl wrapper"
      onMouseEnter={() => {
        if (swiperInstance) {
          swiperInstance.autoplay.stop()
        }
      }}
      onMouseLeave={() => {
        if (swiperInstance) {
          swiperInstance.autoplay.start()
        }
      }}
    >
      <Swiper {...params} className="swiper-class">
        {bannerWithAd.map((banner, index) => {
          if ((banner as ISwiperAD).materiel_str) {
            return (
              <SwiperSlide key={index}>
                <div>
                  <SwiperAD
                    key={index}
                    data={banner as ISwiperAD}
                    index={index}
                  />
                </div>
              </SwiperSlide>
            )
          }
          const bannerItem = banner as IBannerList
          return (
            <SwiperSlide key={index}>
              <ArticleLink
                key={index}
                gid={bannerItem.gid}
                onClick={() => {
                  sendTeaCommEvent('click_home_banner', {
                    group_id: bannerItem.gid,
                    rank: index,
                    material_url: applyHttpsImage(
                      `${bannerItem?.img_url || ''}.jpg`
                    ),
                  })
                }}
              >
                <img
                  src={applyHttpsImage(`${bannerItem?.img_url || ''}.jpg`)}
                  className="wrapper"
                />
              </ArticleLink>
            </SwiperSlide>
          )
        })}
        <div className="banner-nav-pre swiper-nav-pre tw-inline-block" />
        <div className="banner-nav-next swiper-nav-next tw-inline-block" />
        <div className="banner-swiper-pagination tw-flex" />
      </Swiper>
      <style jsx>
        {`
          .wrapper {
            display: inline-block;
            width: 800px;
            min-width: 800px;
            height: 316px;
            min-height: 316px;
            overflow: hidden;
            background-size: cover;
            border-radius: 2px;
          }
          img {
            width: 100%;
            vertical-align: middle;
          }
          :global(.swiper-class .banner-swiper-pagination) {
            @apply tw-w-100 tw-absolute tw-h-4 tw-bottom-8 tw-right-4 tw-z-1 tw-items-center tw-justify-end;
            left: auto;
          }
          :global(.swiper-class .banner-bullet) {
            @apply tw-h-4 tw-w-32 tw-bg-white tw-mr-4 tw-cursor-pointer;
          }
          :global(.swiper-class .banner-bullet.banner-active-bullet) {
            @apply tw-w-32;
            background-color: #ffcd32;
          }
        `}
      </style>
    </div>
  )
}
